import React from 'react';
import FacebookLogo from '../../assets/imgs/socialMedia/facebook.svg';
import InstagramLogo from '../../assets/imgs/socialMedia/instagram.svg';
import LinkedInLogo from '../../assets/imgs/socialMedia/linkedin.svg';
import TikTokLogo from '../../assets/imgs/socialMedia/tiktok.svg';
import ThreadsLogo from '../../assets/imgs/socialMedia/threads.svg';

const SocialMedia = () => {
  return (
    <div className="flex items-center justify-center gap-2">
      <a href="https://www.facebook.com/factorksoftware" target="_blank" rel="noreferrer">
        <div className="w-12 h-12 flex items-center justify-center bg-white border border-white-50 rounded-full hover:scale-105 transition ease-out">
          <img src={FacebookLogo} alt="Facebook" className="w-7 h-7" />
        </div>
      </a>
      <a href="https://www.instagram.com/factorksoftware/" target="_blank" rel="noreferrer">
        <div className="w-12 h-12 flex items-center justify-center bg-white border border-white-50 rounded-full hover:scale-105 transition ease-out">
          <img src={InstagramLogo} alt="Instagram" className="w-7 h-7" />
        </div>
      </a>
      <a href="https://www.linkedin.com/company/factork-software-company/" target="_blank" rel="noreferrer">
        <div className="w-12 h-12 flex items-center justify-center bg-white border border-white-50 rounded-full hover:scale-105 transition ease-out">
          <img src={LinkedInLogo} alt="LinkedIn" className="w-7 h-7" />
        </div>
      </a>
      <a href="https://www.tiktok.com/@factorksoftware" target="_blank" rel="noreferrer">
        <div className="w-12 h-12 flex items-center justify-center bg-white border border-white-50 rounded-full hover:scale-105 transition ease-out">
          <img src={TikTokLogo} alt="TikTok" className="w-7 h-7" />
        </div>
      </a>
      <a href="https://www.threads.com/@factorksoftware" target="_blank" rel="noreferrer">
        <div className="w-12 h-12 flex items-center justify-center bg-white border border-white-50 rounded-full hover:scale-105 transition ease-out">
          <img src={ThreadsLogo} alt="Threads" className="w-7 h-7" />
        </div>
      </a>
    </div>
  );
};

export default SocialMedia;
